import { ErrorMessageConstant } from '@/supports/error-message.constant'

/**
 * Handler action with error message in application
 */
export default new (class ErrorMessageService {
  /**
   *
   * Get error message in api or message validate vue
   *
   * @param messages
   * @param columns
   */
  getMessageError(messages: any, columns: any) {
    if (!columns) {
      return this.__getMessageError(messages, columns)
    }

    columns = columns.split(',')
    if (!Array.isArray(columns)) {
      return this.__getMessageError(messages, columns)
    }

    for (const column of columns) {
      const message = this.__getMessageError(messages, column)
      if (message) {
        return message
      }
    }
    return ''
  }

  /**
   *
   * Get one message error
   *
   * @param messages
   * @param column
   */
   __getMessageError(messages: any, column: any) {
    let errorMessage = ''
    if (messages) {
      if (typeof messages === 'string' && (column === null || column === '')) {
        return messages
      }
      // Get message error in api
      if (typeof messages[column] !== 'undefined') {
        return typeof messages[column] !== 'string' ? messages[column][0] : messages[column]
      }
    } else {
      errorMessage = ErrorMessageConstant.ERROR_SYSTEM
    }
    return errorMessage
  }

  /**
   * Remove error message
   *
   * @param column
   */
  removeError(column: string) {
    // const obj_column = column
    //   .split(',')
    //   .reduce((obj: any, val: string) => ((obj[val] = ''), obj), {})
    // store.commit('setErrorMessage', obj_column)
  }

  /**
   * Check multiple column is error with validate frontend or api
   *
   * @param columns
   */
  // hasErrorMessageByColumn(columns: any) {
  //   if (!columns) {
  //     return false
  //   }
  //   columns = columns.split(',')
  //   for (const column of columns) {
  //     const hasErrorMessageByColumn = this.__hasErrorMessageByColumn(column)
  //     if (hasErrorMessageByColumn) {
  //       return hasErrorMessageByColumn
  //     }
  //   }
  //   return false
  // }

  /**
   * Check column is error with validate frontend or api
   *
   * @param column
   * @private
   */
  //  __hasErrorMessageByColumn(column: string) {
  //   let errorMessage = store.getters.getErrorMessage.message
  //   if (typeof errorMessage !== 'object') {
  //     return false
  //   }
  //
  //   if (
  //     typeof errorMessage.response !== 'undefined' &&
  //     typeof errorMessage.response.data !== 'undefined'
  //   ) {
  //     errorMessage = errorMessage.response.data.message
  //   }
  //
  //   if (!errorMessage) {
  //     return false
  //   }
  //
  //   if (typeof errorMessage[column] === 'undefined' || !errorMessage[column]) {
  //     return false
  //   }
  //   return true
  // }

  /**
   * Handler get error message
   *
   * @param messages
   * @param column
   */
  async getErrorMessage(messages: any) {
    if (!messages || messages.code === 200) {
      return
    }
    // Begin Handler message is string
    if (typeof messages === 'string') {
      return messages;
    }
    if (messages.message && typeof messages.message === 'string') {
      return messages;
    }
    // End Handler message is string

    // Handler response api validate
    return this.detectErrorMessageJson(messages)
  }

  /**
   * Get error message with json format
   *
   * @param messages
   * @param column
   */
  detectErrorMessageJson(error: any) {
    const DEFAULT_MESSAGE = [ErrorMessageConstant.ERROR_SYSTEM];

    if (!error?.response?.data) {
      return DEFAULT_MESSAGE;
    }

    const message = error.response.data.message;

    if (!message || message === 'Internal server error' || error.response.status === 500) {
      return DEFAULT_MESSAGE;
    }

    if (typeof message === 'object') {
      return this.prepareMessage(message);
    }

    return message;
  }

  prepareMessage(messages: Object) {
    const prepareMessages = []
    for (const [key, value] of Object.entries(messages)) {
      switch (value) {
        case "EA0007":
          prepareMessages.push('Email công ty đăng kí đã tồn tại trên hệ thống')
          break;
        case "EA0071":
          prepareMessages.push('Email người dùng đăng kí đã tồn tại trên hệ thống')
          break;
        case "EA0011":
          prepareMessages.push('Mã công ty đăng kí đã tồn tại trên hệ thống')
          break;
        default:
          prepareMessages.push(value)
          break;

      }
    }

    return prepareMessages
  }
})()
